export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: 'AIzaSyDU5Q0liEGfRuQ9yq7pCBLsN6ct_UunoNg',
    authDomain: 'tangram-546f2.firebaseapp.com',
    databaseURL: 'https://tangram-546f2.firebaseio.com',
    projectId: 'tangram-546f2',
    storageBucket: 'tangram-546f2.appspot.com',
    messagingSenderId: '467809878400',
    appId: '1:467809878400:web:294b6d3bba2843d9'
  },
  appTitle: 'Tangram',
  userApiBaseUrl: 'https://us-central1-tangram-546f2.cloudfunctions.net/api'
};
